/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const productReleases = sqliteTable('product_releases', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  release_number: text('release_number'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  invoice_id: text('invoice_id'),
  status: text('status'),
  released_at: text('released_at'),
  released_by: text('released_by'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
